import React, { useState, useEffect } from 'react';
import {
  withRouter, Route
} from 'react-router-dom';
import "./ProductDynamicDetailPage.less";
import Axios from '../../core/axios';
import Header from '../home/Header';
import moment from 'moment';
import { Icon } from 'antd';

const ProductDynamicDetailPage = (props: any) => {
  let id = props.location.pathname.indexOf('/', 5) !== -1 ? props.location.pathname.slice(props.location.pathname.indexOf('/', 5) + 1) : "";
  const [contentStringdata, setData] = useState({ linkContent: "",title:"",displayTime:"" });

  useEffect(() => {
    Axios.postJSON("manage/anon/productDynamic/queryProductDynamic", { id })
      .then((res: any) => {
        setData(res.result);
      })
      .catch(res => { })
  },[id])

  function goBack() { 
    props.history.push(`/product_dynamic`);
  }

  let contentString: string = contentStringdata.linkContent;
  let displayTime: string = contentStringdata.displayTime;
  let title: string = contentStringdata.title;
  return (
    <div className="product-dynamic-detail-page">
      <div className='top'>
        <Header />
      </div>
      <div className='content-box'>
        <div className="position-title">
          <span>
            <Icon type="left" className='mr5 left-arrow' />
          </span>
          <span
            onClick={goBack}
            style={{ cursor: "pointer" }}
          >{' 返回产品动态'}</span>
        </div>
        <div className="detail-content">
          <div className="title">{title}</div>
          <div className="date">{moment(displayTime).format("YYYY-MM-DD")}</div>
          <div className="context" dangerouslySetInnerHTML={{ __html: contentString }}></div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(ProductDynamicDetailPage);
